import * as React from "react";
const CourseMenu = ({ color = "#276AA6", ...props }) => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 17.97H7C3 17.97 1 16.97 1 11.97V6.96997C1 2.96997 3 0.969971 7 0.969971H15C19 0.969971 21 2.96997 21 6.96997V11.97C21 15.97 19 17.97 15 17.97H14.5C14.19 17.97 13.89 18.12 13.7 18.37L12.2 20.37C11.54 21.25 10.46 21.25 9.8 20.37L8.3 18.37C8.14 18.15 7.77 17.97 7.5 17.97Z"
      stroke={color}
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 6.96997H16"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 11.97H12"
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default CourseMenu;